/** All available taxation types */
export enum TaxationTypeEnum {
  GENERAL = 'GENERAL', // ОСН - Общая система налогообложения
  SINGLE_IMPUTED_INCOME = 'SINGLE_IMPUTED_INCOME', // ЕНВД - Единый налог на вменённый доход
  SINGLE_AGRICULTURAL = 'SINGLE_AGRICULTURAL', // ЕСХН - Единый сельскохозяйственный налог
  PATENT = 'PATENT', // ПНС - Патентная система налогообложения
  SIMPLIFIED_15 = 'SIMPLIFIED_15', // УСН 15% - Упрощённая система налогообложения (разница между доходами и расходами)
  SIMPLIFIED_6 = 'SIMPLIFIED_6', // УСН 6% - Упрощённая система налогообложения (вся выручка)
}
